<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی ذی نفعان قدرت منفعت</h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <hr class="mb-3">
            <center v-if="!status">
              {{ error }}
            </center>
            <div v-if="status" class="overflow-scroll" style="height: 27vw;">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th style="width: 1vw;" class="sticky-header" rowspan="2" >
                    <span > ردیف </span>

                  </th>
                  <th class="sticky-header" rowspan="2">
                    <span style="position:absolute; top: 30%; right: 35%;"> دسته بندی</span>
                  </th>
                  <th class="sticky-header" rowspan="2">
                    <span style="position:absolute; top: 30%; right: 42%;"> گروه</span>
                  </th>
                  <th class="sticky-header" rowspan="2">
                    <span style="position:absolute; top: 30%; right: 42%;"> ذی نفع </span>
                  </th>
                </tr>
                <tr class="sticky-header">
                  <th>قدرت</th>
                  <th>مسئولیت</th>
                  <th>فوریت</th>
                </tr>
                </thead>
                <tbody>
                <beneficiary-row
                    v-for="(item, index) in all_beneficiary"
                    :key="item.id"
                    :item="item"
                    :index="index"
                    @update="updateBeneficiary"
                ></beneficiary-row>
                </tbody>
              </table>
            </div>
            <hr class="mt-2 mb-2"  v-if="status">
            <center>
              <button v-if="status" class="btn btn-submit-1 btn-primary" @click="saveAll">ذخیره</button>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import BeneficiaryRow from "@/components/beneficiary/BeneficiaryRowMitchell.vue";
import { useToast } from "vue-toastification";
import router from "@/router";

const toast = useToast();

export default {
  name: "beneficiary_id_order_by",
  components: { Sidebar, Splash, BeneficiaryRow },
  data() {
    return {
      items: [],
      status: false,
      error: 'دوره ای برای ارزیابی ذی نفعان تعریف نشده است.',
      all_beneficiary: [],
      updated_beneficiaries: [],
    };
  },
  methods: {
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryPeriod/show`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.status = false;
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            if (response.item) {
              this.status = true;
              this.all_beneficiaryMethod();
            }
          })
          .catch();
    },
    all_beneficiaryMethod() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/all_for_mitchell`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            this.all_beneficiary = [...response.all];
          })
          .catch();
    },
    updateBeneficiary(updatedItem) {
      const index = this.updated_beneficiaries.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        this.updated_beneficiaries[index] = updatedItem;
      } else {
        this.updated_beneficiaries.push(updatedItem);
      }
    },
    saveAll() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({ items: this.updated_beneficiaries }),
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary_mitchell/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error);
              return;
            }
            toast.success('داده‌ها با موفقیت ذخیره شدند.');
          })
          .catch(error => {
            toast.error('خطایی رخ داده است.');
          });
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/pishkhan')
      }else if (this.type_one){
        router.push('/beneficiary/order_by/mitchell_for_management')

      }

      return;
    }
  },
  mounted() {
    this.checkIsMother();
    this.all();
  }
};
</script>

<style scoped>
.row {
  padding: .5vw;
}
h3 {
  font-size: 1.5vw !important;
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}
</style>
